import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { provideRouter } from "@angular/router";

// Local file
import { routes } from './routes';


@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    provideRouter(routes),
  ]
})
export class WagerFeatureMatModule {}

/**
 * Export component to be use outside
 */
export * from './components/replay-video/replay-video.component';
export * from './components/bet-summary/bet-summary.component';